"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation deleteOrganizationFee($orgId: String!, $feeId: String!) {
    deleteOrganizationFee(orgId: $orgId, feeId: $feeId)
  }
`;
exports.default = mutation;
//# sourceMappingURL=deleteOrganizationFee.mutation.js.map